import { z } from 'zod';

const dependientes = z.object({
  tipoIdentificacion: z.string().min(1, {
    message: 'Tipo de identificación requerido',
  }),
  numeroIdentificacion: z.string().min(1, {
    message: 'Número de identidad requerido',
  }),
  nombreCompleto: z.string().min(1, {
    message: 'Nombre completo requerido',
  }),
  fechaNacimiento: z.string().min(1, {
    message: 'Fecha de nacimiento requerido',
  }),
  genero: z.string().min(1, {
    message: 'Género requerido',
  }),
  parentesco: z.string().min(1, {
    message: 'Parentesco requerido',
  }),
});

export const formAddDependientesSchema = z.object({
  dependientes: z.array(dependientes),
});
